import { AppThunk } from '../../../store/rootReducer';
import * as updateActions from '../actions/update.actions';
import { isUpdatingSelector } from '../selectors/update.selectors';

export const setWaveTimestamp = (timestamp: number): AppThunk => async (
  dispatch,
  getState,
) => {
  const isUpdating = isUpdatingSelector(getState());

  if (isUpdating) {
    dispatch(
      updateActions.setTimestamp({ timestamp, meta: { history: false } }),
    );
  }
};
